import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {View, Vibration} from 'react-native';
import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';
///////////////////////////
///////////// components
import {ContinueButton, BodyText} from 'src/Modules/CommonView';

///////////////////////////
///////////// utils
import {markSelectionChallengeComplete} from 'src/Utils/huntFunctions_v2';

import {useChallenge} from '../../Hooks/gameHooks';
import Slider from '@react-native-community/slider';

function random(seed = 0) {
  var x = Math.sin(seed++) * 10000;
  return x - Math.floor(x);
}

const NumberGuesser = ({onComplete, singleCompletion}) => {
  const userId = useSelector((state) => state.user?.info?.userId);
  const groupId = useSelector((state) => state.groupInfo?.groupId);

  const challenge = useChallenge();
  const {correctAnswer = 0} = challenge || {};

  const minGuess = Math.max(Math.round(correctAnswer / 10) * 10 - 20, 0);
  const maxGuess =
    Math.round(correctAnswer / 10) * 10 +
    20 +
    Math.round(random(correctAnswer * 123442) / 3) * 10;

  const [guess, setGuess] = useState(Math?.floor((maxGuess + minGuess) / 2));

  const roundedGuess = Math.round(guess);

  useEffect(() => {
    setGuess(Math?.floor((maxGuess + minGuess) / 2));
  }, [correctAnswer]);

  const handleSubmit = () => {
    const {correctAnswer, challengeId} = challenge;

    markSelectionChallengeComplete({
      userId,
      challengeId,
      option: roundedGuess,
      correct: roundedGuess === parseInt(correctAnswer),
      groupId,
      singleCompletion,
      challenge,
    });

    if (guess != parseInt(correctAnswer)) {
      Vibration.vibrate(400);
    }

    onComplete && onComplete?.();
  };

  const {completions = {}} = challenge;
  const userHasCompleted = completions[userId] ? true : false;

  const {width} = useWindowDimensionsSafe();

  return (
    <View
      style={{
        justifyContent: 'center',
      }}>
      {!userHasCompleted && (
        <View style={{alignItems: 'center'}}>
          <BodyText
            textStyle={{
              textAlign: 'center',

              fontSize: 28,
              lineHeight: 28,
            }}
            largeText
            text={roundedGuess}
          />
          <Slider
            testID={'numberGuesser'}
            style={{width: width - 20}}
            value={guess}
            onValueChange={(newValue) => {
              console.log({newValue});
              setGuess(newValue);
            }}
            minimumValue={minGuess}
            maximumValue={maxGuess}
            tapToSeek={1}
          />

          <ContinueButton
            text={'Submit'}
            containerStyle={{width: 220, marginVertical: 5, marginTop: 10}}
            background={global?.color?.orange}
            handlePress={handleSubmit}
          />
        </View>
      )}
      {!!userHasCompleted && (
        <View style={{marginTop: 20}}>
          {!!guess && (
            <ContinueButton
              text={completions[userId].option}
              containerStyle={{flex: 1, marginVertical: 5}}
              background={global?.color?.orange}
            />
          )}
        </View>
      )}
    </View>
  );
};

export default NumberGuesser;
